import { BASE_URL } from "../constants/apis";

// Backend may return either an absolute CDN URL (CloudFront) or a legacy relative media path.
export const resolveMediaUrl = (path) => {
    if (!path) return null;
    return /^https?:\/\//i.test(path) ? path : `${BASE_URL}${path}`;
};
